import { createBrowserHistory } from 'history';
export const doNotDispatch = {
    flag: false,
};
const browserHistory = createBrowserHistory();
export const history = {
    push(to) {
        browserHistory.push(to);
    },
    replace(to) {
        browserHistory.replace(to);
    },
    replaceWithoutDispatch(to) {
        doNotDispatch.flag = true;
        browserHistory.replace(to);
    },
    listen(updateRoute) {
        return browserHistory.listen(updateRoute);
    },
    get location() {
        return browserHistory.location;
    },
};
//# sourceMappingURL=history.js.map